(() => {
  // src/js/components/collapse.js
  var Collapse = class {
    constructor(elements, responsive) {
      this.elements = elements;
      this.responsive = responsive;
    }
    static createCollapsible(_params) {
      const p = _params;
      let blockClass = "js-blockCollapse";
      let buttonClass = "js-blockCollapseToggle";
      let innerClass = "js-blockCollapseInner";
      let responsive = false;
      let elements = [];
      if (p) {
        blockClass = p.blockClass ? p.blockClass : blockClass;
        buttonClass = p.buttonClass ? p.buttonClass : buttonClass;
        innerClass = p.innerClass ? p.innerClass : innerClass;
        responsive = p.responsive ? p.responsive : false;
        elements = p.elements ? p.elements : elements;
      }
      const blocks = elements.length > 0 ? elements : document.querySelectorAll(`.${blockClass}`);
      if (!blocks.length)
        return null;
      blocks.forEach((block) => {
        const button = block.querySelector(`.${buttonClass}`);
        const inner = block.querySelector(`.${innerClass}`);
        const innerHeight = inner.firstElementChild.scrollHeight;
        const blockBreakpoint = block.dataset.end;
        const group = block.dataset.group;
        const id = block.id;
        let state = true;
        if (blockBreakpoint && responsive) {
          const isBreakpointActive = responsive.isBreakpointActive(blockBreakpoint);
          if (!isBreakpointActive) {
            inner.style.overflow = "hidden";
          }
          if (isBreakpointActive) {
            inner.style.overflow = "visible";
            button.disabled = true;
            block.classList.add("kill-collapse");
          }
        }
        if (!blockBreakpoint) {
          inner.style.overflow = "hidden";
        }
        const obj2 = {
          block,
          button,
          inner,
          innerHeight,
          state,
          group: group ? group : false,
          blockBreakpoint: blockBreakpoint ? blockBreakpoint : false,
          id: id ? id : false
        };
        elements.push(obj2);
      });
      const obj = new Collapse(elements, responsive);
      obj.update();
      obj.initItemListener();
      return obj;
    }
    initItemListener() {
      this.elements.forEach((element) => {
        const button = element.button;
        button.addEventListener("click", () => {
          this.update(element);
          window.Store.scrollbar.updateAfterTransitionEnd(element.inner.firstElementChild);
        });
      });
    }
    update(element) {
      if (!element) {
        this.elements.forEach((element2) => {
          const state = element2.state;
          const blockBreakpoint = element2.blockBreakpoint;
          const isBreakpointActive = this.responsive.isBreakpointActive(blockBreakpoint);
          if (blockBreakpoint) {
            if (!isBreakpointActive) {
              if (state) {
                element2.block.classList.remove("is-open");
                element2.inner.firstElementChild.style.height = `0px`;
              }
              if (!state) {
                element2.block.classList.add("is-open");
                element2.inner.firstElementChild.style.height = `${element2.innerHeight}px`;
              }
            }
            if (isBreakpointActive) {
              element2.block.classList.remove("is-open");
              element2.inner.firstElementChild.style.height = "auto";
            }
            element2.state = !state;
            return;
          }
          if (state) {
            element2.block.classList.remove("is-open");
            element2.inner.firstElementChild.style.height = `0px`;
          }
          if (!state) {
            element2.block.classList.add("is-open");
            element2.inner.firstElementChild.style.height = `${element2.innerHeight}px`;
          }
          element2.state = !state;
        });
      }
      if (element) {
        const received_element = element;
        const clicked_group = element.group;
        this.elements.forEach((element2) => {
          if (element2 != received_element) {
            const state2 = element2.state;
            const group = element2.group;
            if (state2 && clicked_group && clicked_group == group) {
              element2.state = false;
              element2.block.classList.remove("is-open");
              element2.inner.firstElementChild.style.height = `0px`;
            }
          }
        });
        const state = element.state;
        if (state) {
          element.block.classList.remove("is-open");
          element.inner.firstElementChild.style.height = `0px`;
        }
        if (!state) {
          element.block.classList.add("is-open");
          element.inner.firstElementChild.style.height = `${element.innerHeight}px`;
        }
        element.state = !state;
      }
    }
    updateOnResize() {
      this.elements.forEach((element) => {
        const state = element.state;
        if (!element.blockBreakpoint) {
          if (state) {
            element.inner.firstElementChild.style.height = "auto";
            element.innerHeight = element.inner.firstElementChild.scrollHeight;
            element.inner.firstElementChild.style.height = `${element.innerHeight}px`;
            return;
          }
          element.innerHeight = element.inner.firstElementChild.scrollHeight;
          return;
        }
        const isBreakpointActive = this.responsive.isBreakpointActive(element.blockBreakpoint);
        if (!isBreakpointActive) {
          element.inner.style.overflow = "hidden";
          element.button.disabled = false;
          element.block.classList.remove("kill-collapse");
          if (state) {
            element.inner.firstElementChild.style.height = "auto";
            element.innerHeight = element.inner.firstElementChild.scrollHeight;
            element.inner.firstElementChild.style.height = `${element.innerHeight}px`;
            return;
          }
          element.innerHeight = element.inner.firstElementChild.scrollHeight;
          element.inner.firstElementChild.style.height = `0px`;
          return;
        }
        if (state) {
          element.block.classList.remove("is-open");
          element.state = !state;
        }
        element.inner.style.overflow = "visible";
        element.button.disabled = true;
        element.block.classList.add("kill-collapse");
        element.innerHeight = "auto";
        element.inner.firstElementChild.style.height = `${element.innerHeight}`;
      });
    }
  };
  function render() {
    window.Store.components.collapse.obj = Collapse.createCollapsible({ responsive: window.Store.app.responsive });
  }
  window.Store.components.collapse = {
    obj: null,
    render: null
  };
  window.Store.components.collapse.render = render;
})();
